import { render, staticRenderFns } from "./ReviewPaymentMethod.vue?vue&type=template&id=1f22a1b0&scoped=true&"
import script from "./ReviewPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./ReviewPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22a1b0",
  null
  
)

export default component.exports